<script>
export default {
  name: "CardButton",
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div
      class="mt-4 flex justify-center py-1 items-center bg-gradient-to-r from-[#00BADE] to-[#00DFDE] text-white shadow-lg rounded-2xl">
    <div class="w-1/7">
      <svg xmlns="http://www.w3.org/2000/svg" height="51" viewBox="0 0 128 128" width="51" class="fill-white">
        <g>
          <path
              d="m109.413 90.2-37.259-64.535a9.416 9.416 0 0 0 -16.308 0l-37.259 64.535a9.416 9.416 0 0 0 8.154 14.123h74.518a9.416 9.416 0 0 0 8.154-14.123zm-3.031 7.665a5.855 5.855 0 0 1 -5.123 2.958h-74.518a5.916 5.916 0 0 1 -5.123-8.873l37.259-64.535a5.916 5.916 0 0 1 10.246 0l37.259 64.535a5.856 5.856 0 0 1 0 5.915z"></path>
          <path
              d="m64.485 44.694h-.97a6.09 6.09 0 0 0 -6.084 6.083v20.71a6.091 6.091 0 0 0 6.084 6.084h.97a6.091 6.091 0 0 0 6.084-6.084v-20.71a6.09 6.09 0 0 0 -6.084-6.083zm2.584 26.793a2.587 2.587 0 0 1 -2.584 2.584h-.97a2.587 2.587 0 0 1 -2.584-2.584v-20.71a2.586 2.586 0 0 1 2.584-2.583h.97a2.586 2.586 0 0 1 2.584 2.583z"></path>
          <path
              d="m64 80.859a6.569 6.569 0 1 0 6.569 6.569 6.577 6.577 0 0 0 -6.569-6.569zm0 9.641a3.069 3.069 0 1 1 3.069-3.069 3.072 3.072 0 0 1 -3.069 3.069z"></path>
        </g>
      </svg>
    </div>
    <div class="w-3/4 pl-2">
      <span class="lg:text-xl font-bold">{{title}}</span>
    </div>
  </div>
</template>